import {
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_VISUAL_INTEREST,
  ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4,
  ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE,
  ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE,
  ASSET_CONTENT_REFERENCE_TYPE_PORTRAIT,
  ASSET_CONTENT_REFERENCE_TYPE_LOGO,
  ASSET_CONTENT_REFERENCE_TYPE_TERM,
  ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT,
  ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT,
} from 'services/assets/content-reference-types'
import { CONTENT_TYPE_COURSE } from 'services/content/content-types'

const HERO_IMAGES_TYPES = [
  { title: 'Hero No Text', type: ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_NO_TEXT },
  { title: 'Hero With Text', type: ASSET_CONTENT_REFERENCE_TYPE_D6_HERO_WITH_TEXT },
]

const KEYART_16X9_IMAGES_TYPES = [
  { title: 'Keyart No Text', type: ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_NO_TEXT },
  { title: 'Keyart With Text', type: ASSET_CONTENT_REFERENCE_TYPE_D6_KEYART_WITH_TEXT },
  { title: 'Keyart 2K Text', type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_WITH_TEXT },
  { title: 'Keyart 2K No Text', type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_2K_NO_TEXT },
  { title: 'Keyart 4K Text', type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_WITH_TEXT },
  { title: 'Keyart 4K No Text', type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_4K_NO_TEXT },
]

const KEYART_4X3_IMAGES_TYPES = [
  { title: 'Keyart 4X3 Text', type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_4X3_WITH_TEXT },
]

const KEYART_2X3_IMAGES_TYPES = [
  { title: 'Keyart 2X3 Text', type: ASSET_CONTENT_REFERENCE_TYPE_KEYART_2X3_WITH_TEXT },
]

const POSTER_IMAGES_TYPES = [
  { title: 'Poster 3x4', type: ASSET_CONTENT_REFERENCE_TYPE_POSTER_3X4 },
  { title: 'Poster CVR', type: ASSET_CONTENT_REFERENCE_TYPE_POSTER_IMAGE },
]

const ONE_BY_ONE_IMAGES_TYPES = [
  { title: '1x1 Text', type: ASSET_CONTENT_REFERENCE_TYPE_1X1_WITH_TEXT },
  { title: '1x1 No Text', type: ASSET_CONTENT_REFERENCE_TYPE_1X1_NO_TEXT },
]

const PERSON_IMAGES_TYPES = [
  { title: 'Person Headshot Circle', type: ASSET_CONTENT_REFERENCE_TYPE_PERSON_HEADSHOT_CIRCLE },
  { title: 'Person Headshot', type: ASSET_CONTENT_REFERENCE_TYPE_HEADSHOT },
  { title: 'Portrait', type: ASSET_CONTENT_REFERENCE_TYPE_PORTRAIT },
  { title: 'Term', type: ASSET_CONTENT_REFERENCE_TYPE_TERM },
]

const LOGO_IMAGES_TYPES = [{ title: 'Logo', type: ASSET_CONTENT_REFERENCE_TYPE_LOGO }]

const TOPICS_ROW_IMAGES_TYPES = [
  { title: 'Topics Row Image', type: ASSET_CONTENT_REFERENCE_TYPE_TOPICS_ROW },
]

const VISUAL_INTEREST_IMAGES_TYPES = [
  { title: 'Visual Interest Image', type: ASSET_CONTENT_REFERENCE_TYPE_VISUAL_INTEREST },
]

export const getContentImagesTypes = (contentType: string) => {
  switch (contentType) {
    case CONTENT_TYPE_COURSE:
      return [
        ...HERO_IMAGES_TYPES,
        ...POSTER_IMAGES_TYPES,
        ...KEYART_16X9_IMAGES_TYPES,
        ...KEYART_4X3_IMAGES_TYPES,
        ...LOGO_IMAGES_TYPES,
        ...ONE_BY_ONE_IMAGES_TYPES,
      ]
    default:
      // Default to all images types
      return [
        ...HERO_IMAGES_TYPES,
        ...POSTER_IMAGES_TYPES,
        ...KEYART_16X9_IMAGES_TYPES,
        ...KEYART_4X3_IMAGES_TYPES,
        ...KEYART_2X3_IMAGES_TYPES,
        ...ONE_BY_ONE_IMAGES_TYPES,
        ...PERSON_IMAGES_TYPES,
        ...LOGO_IMAGES_TYPES,
        ...TOPICS_ROW_IMAGES_TYPES,
        ...VISUAL_INTEREST_IMAGES_TYPES,
      ]
  }
}
